'use strict';
import React from 'react';

/**
 * TableData component.
 * Defines styling for a table Data
 * Adding a Table-smCardLabel child element to a <td> element will display an
 * inline label for that element on viewports smaller than 767px.
 *
 * @extends {React.Component}
 */
class TableData extends React.Component {

  /**
   * Render the component
   *
   * @return {JSX} JSX component markup.
   **/
  render () {
    const { children, ...otherProps } = this.props;
    return (
      <td {...otherProps}>
        { children }
      </td>
    );
  }
}

export default TableData;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/components/table/tableData.jsx